import React from 'react';
import { Job } from './components/Tabs/Job';
import { InspectionCalendar } from './components/Tabs/Calendar';

export const InspectionTabs = [
  {
    key: 'inspection-job',
    label: 'All Job',
    children: <Job />
  },
  {
    key: 'inspection-calendar',
    label: 'Onsite Job Calendar',
    children: <InspectionCalendar />
  }
];
